import React from 'react';
import {StyleSheet, View, Text} from "../Primitives";
// Create styles
const styles = StyleSheet.create({
    box:{
        display:'flex',
        flex:1,
        border: '1pt solid #000',
        padding:15,


    },
    header:{
        fontSize:9,
        paddingBottom:2,
    },
    bodyText: {
        marginBottom:5,
        fontSize:7,
        lineHeight:1.3
    },
    flexContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-between',
        marginLeft:30,
        marginRight:30,
    },
    flexBox:{
        display:'flex',
        flex:1,
        border: '1pt solid #006CAA',
        padding: 8,
        marginBottom: 15,
    },
    redBold:{
        fontSize:7,
        lineHeight:1.3,
        color:'red',
        fontWeight: '600',
        },
});



const CheckInAndDeparture = ({charter}) =><View style={styles.flexBox}>

        <Text style={styles.header}>AVMIN Check In & Departure Information</Text>
        <Text style={styles.bodyText}>
            To allow for an on time departure, we recommend that you arrive at least 
            <Text style={styles.redBold}> 30 minutes </Text>prior to the scheduled departure time to allow sufficient time
            for the check in process, safety briefing and boarding to be completed.
        </Text>
        <Text style={styles.bodyText}>
            Please take note of the maximum aircraft payload on each sector.
            The payload figure is always subject to weather on the day of the flight.
            This is the total available weight for all passengers and their luggage.
        </Text>



</View>

export default CheckInAndDeparture

